import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Member } from 'app/service/member/member';
import { ShareService } from 'app/service/share/share.service';
import * as moment from "moment";
import { MemberService } from "../../service/member/member.service";

declare let window: any;

interface IQRcode {
  qrcode: string;
  expiryDate: string;
}
@Component({
  selector: 'app-member-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [MemberService]
})
export class MemberHomeComponent implements OnInit {
  isMobile: boolean = false;
  page: any;
  pass: IQRcode = {} as IQRcode;
  me: Member;

  constructor(
    private memberService: MemberService,
    private shareService: ShareService,
    private router: Router
  ) {
    this.shareService.awaitMe().subscribe(
      me => {
        this.me = me;
      }
    );
  }


  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;

      if (!this.isMobile) this.router.navigate(['member/home']);
    }
  }

  ngOnInit(): void {
    this.isMobile = (window.innerWidth < 768);

    if (!this.isMobile) this.router.navigate(['member/home']);

    this.memberService.getHomePage().subscribe(
      res => {
        this.page = res;
        this.page.reserved = this.page.reserved.map(o => {
          return {
            ...o,
            de_use: moment(o.de_use, 'YYYYMMDD').format('YYYY-MM-DD'),
            time_use_end: `${o.time_use_end.substr(0, 2)}:${o.time_use_end.substr(2, 2)}`,
            time_use_start: `${o.time_use_start.substr(0, 2)}:${o.time_use_start.substr(2, 2)}`,
          }
        })
      }
    )

    this.memberService.getQRCode().subscribe(
      res => this.pass = res as IQRcode
    )

    window.push.update();
  }

  thumbStep: number = 0;

  onThumbScroll(e: Event) {
    this.thumbStep = parseInt(`${(e.srcElement.scrollLeft + 100) / 250}`)
  }

  isShowQRCodeModal: boolean = false;
  openQRCodeModal(type: string) {
    const expiryDate = moment(this.pass.expiryDate || new Date(), 'YYYY-MM-DD HH:mm');
    if (type == 'sh' || moment().isSameOrAfter(expiryDate)) {
      this.memberService.getQRCode(type).take(1).subscribe(
        res => {
          this.pass = res as IQRcode;
          this.isShowQRCodeModal = true;
        }
      )
    } else {
      this.memberService.getQRCode().take(1).subscribe(
        res => {
          this.pass = res as IQRcode;
          this.isShowQRCodeModal = true;
        }
      )
      // this.isShowQRCodeModal = true;
    }
  }

  goCommunity(id: number) {
    history.replaceState({}, "", "/#/member/community");
    this.router.navigate(['/member/community', id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/member/home/home.component.ts